__turbopack_context__.v({
  "container": "build-module__CwO5LG__container",
  "floatingEditBar": "build-module__CwO5LG__floatingEditBar",
  "main": "build-module__CwO5LG__main",
  "mapAndBottomBar": "build-module__CwO5LG__mapAndBottomBar",
});
